import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

// Extend dayjs with isoWeek support
import { draftStatus } from '../State/DraftState';

dayjs.extend(quarterOfYear);
dayjs.extend(isoWeek);

export const DrafTableTabs = [
  { label: 'All', value: 'all' },
  { label: 'Assigned To Me', value: 'my_assigned_to_me' },
  { label: 'My Template Tasks', value: 'my_template_tasks' },
  { label: 'My Checklist Tasks', value: 'my_checklist_tasks' },
  { label: 'My Approval Tasks', value: 'my_approval_tasks' },
  { label: 'My Signature Tasks', value: 'my_signature_tasks' },
];

export const myDraftTabs = [
  'my_drafts',
  'my_drafts_under_collaboration',
  'my_approval_pending',
  'my_standstill_draft',
  'my_signed_draft',
  'my_signature_pending',
];

export const allDraftsTabs = [
  'total_drafts',
  'drafts_under_collaboration',
  'approval_pending',
  'standstill_draft',
  'signed_draft',
  'signature_pending',
];

export const initialDraftComponentFilter = {
  approval: null,
  contract: null,
  created_by: null,
  groups: null,
  contract_type: null,
  category: null,
  status: null,
  roles: null,
  assignee: null,
  project: null,
  product_master: null,
  ownparties: null,
  counterparties: null,
  location: null,
  status_alias: null,
  territory: null,
  source_type: null,
  reference_id: null,
};

export const myStatisticTabs = [
  {
    label: 'Total',
    tooltip: 'Total',
    value: 'my_drafts',
    count: 0,
    apiKey: 'total_my_documents',
  },
  {
    label: 'Collaborating',
    tooltip: 'Collaborating',
    value: 'my_drafts_under_collaboration',
    count: 0,
    apiKey: 'my_drafts_under_collaboration',
  },
  {
    label: 'Appr. Pending',
    tooltip: 'Approval Pending',
    value: 'my_approval_pending',
    count: 0,
    apiKey: 'my_approval_pending',
  },
  {
    label: 'Sign. Pending',
    tooltip: 'Signature Pending',
    value: 'my_signature_pending',
    count: 0,
    apiKey: 'my_signature_pending',
  },
  {
    label: 'Signed',
    tooltip: 'Signed',
    value: 'my_signed_draft',
    count: 0,
    apiKey: 'my_signed_draft',
  },
  {
    label: 'Stand Still',
    tooltip: 'Stand Still',
    value: 'my_standstill_draft',
    count: 0,
    apiKey: 'my_standstill_draft',
  },
];

export const statisticTabs = [
  {
    label: 'Total',
    tooltip: 'Total',
    value: 'total',
    count: 0,
    apiKey: 'total_documents',
  },
  {
    label: 'Collaborating',
    tooltip: 'Collaborating',
    value: 'drafts_under_collaboration',
    count: 0,
    apiKey: 'drafts_under_collaboration',
  },
  {
    label: 'Appr. Pending',
    tooltip: 'Approval Pending',
    value: 'approval_pending',
    count: 0,
    apiKey: 'approval_pending',
  },
  {
    label: 'Sign. Pending',
    tooltip: 'Signature Pending',
    value: 'signature_pending',
    count: 0,
    apiKey: 'signature_pending',
  },
  {
    label: 'Signed',
    tooltip: 'Signed',
    value: 'signed_draft',
    count: 0,
    apiKey: 'signed_draft',
  },
  {
    label: 'Stand Still',
    tooltip: 'Stand Still',
    value: 'standstill_draft',
    count: 0,
    apiKey: 'standstill_draft',
  },
];

export const version0Tabs = [
  {
    label: 'Checklist',
    value: 'checklist',
  },
  // {
  //   label: "Applied Policies",
  //   value: "applied_policies",
  //   notIn: 1,
  // },
  // {
  //   label: 'Collaborate',
  //   value: 'collaborate',
  // },
  // {
  //   label: "Access",
  //   value: "access",
  // },
];

export const version1Tabs = [
  // {
  //   label: 'Collaborate',
  //   value: 'collaborate',
  // },
  {
    label: 'Checklist',
    value: 'checklist',
  },
  // {
  //   label: "Access",
  //   value: "access",
  // },
];

export const dropNotShowingStatus = [
  draftStatus?.Automatically_Dropped,
  draftStatus?.COMMITTED_FOR_SIGNATURE,
  draftStatus?.SIGNATURE_ABORTED,
  draftStatus?.SIGNATURE_PENDING,
  draftStatus?.INTERNAL_SIGNATURE_PENDING,
  draftStatus?.EXTERNAL_SIGNATURE_PENDING,
  draftStatus?.CONTRACT_EXECUTED_SUCCESSFULLY,
];

export const restrictionStatus = [
  draftStatus?.Automatically_Dropped,
  draftStatus?.Draft_Dropped,
];

export const dateRangeType = [
  { value: 'custom_range', label: 'Custom Range' },
  {
    value: 'previous_week',
    label: 'Previous Week',
  },
  {
    value: 'this_week',
    label: 'This Week',
  },
  {
    value: 'previous_month',
    label: 'Previous Calendar Month',
  },
  {
    value: 'this_month',
    label: 'This Calendar Month',
  },
  {
    value: 'previous_quarter',
    label: 'Previous Quarter',
  },
  {
    value: 'this_quarter',
    label: 'This Quarter',
  },
  {
    value: 'previous_year',
    label: 'Previous Year',
  },
  {
    value: 'this_year',
    label: 'This Year',
  },
  {
    value: 'completed_months_current_year',
    label: 'Completed Months (Current Year)',
  },
  {
    value: 'completed_months_current_financial_year',
    label: 'Completed Months (Current Financial Year)',
  },
];

export const dateRangeMap: Record<string, string> = {
  previous_week: 'Previous Week',
  this_week: 'This Week',
  previous_month: 'Previous Calendar Month',
  this_month: 'This Calendar Month',
  previous_year: 'Previous Year',
  this_year: 'This Year',
  previous_quarter: 'Previous Quarter',
  this_quarter: 'This Quarter',
};
/**
 * Returns start and end dates for common date range selections
 */
export const getDateRange = (option: string) => {
  const today = dayjs();

  switch (option) {
    case 'previous_week': {
      const start = today.subtract(1, 'week').startOf('isoWeek');
      const end = today.subtract(1, 'week').endOf('isoWeek');
      return { startDate: start, endDate: end };
    }

    case 'this_week': {
      const start = today.startOf('isoWeek');
      const end = today.endOf('isoWeek');
      return { startDate: start, endDate: end };
    }

    case 'previous_month': {
      const start = today.subtract(1, 'month').startOf('month');
      const end = today.subtract(1, 'month').endOf('month');
      return { startDate: start, endDate: end };
    }

    case 'this_month': {
      const start = today.startOf('month');
      const end = today.endOf('month');
      return { startDate: start, endDate: end };
    }

    case 'previous_quarter': {
      const start = today.subtract(1, 'quarter').startOf('quarter');
      const end = today.subtract(1, 'quarter').endOf('quarter');
      return { startDate: start, endDate: end };
    }

    case 'this_quarter': {
      const start = today.startOf('quarter');
      const end = today.endOf('quarter');
      return { startDate: start, endDate: end };
    }

    case 'previous_year': {
      const start = today.subtract(1, 'year').startOf('year');
      const end = today.subtract(1, 'year').endOf('year');
      return { startDate: start, endDate: end };
    }

    case 'this_year': {
      const start = today.startOf('year');
      const end = today.endOf('year');
      return { startDate: start, endDate: end };
    }

    case 'completed_months_current_year': {
      const base = dayjs();

      // If January, no completed months yet
      if (base.month() === 0) {
        return { startDate: null, endDate: null };
      }

      const start = base.startOf('year');
      const end = base.subtract(1, 'month').endOf('month');

      return { startDate: start, endDate: end };
    }

    case 'completed_months_current_financial_year': {
      // Determine start of financial year (April 1st)
      const financialYearStart =
        today.month() >= 3
          ? dayjs().month(3).startOf('month') // April 1st current year
          : dayjs().subtract(1, 'year').month(3).startOf('month'); // April 1st previous year

      const lastCompletedMonth = today.subtract(1, 'month').endOf('month');

      return { startDate: financialYearStart, endDate: lastCompletedMonth };
    }

    default:
      return { startDate: today, endDate: today };
  }
};

export const linkIconNotShow = [
  draftStatus?.COMMITTED_FOR_SIGNATURE,
  draftStatus.CONTRACT_EXECUTED_SUCCESSFULLY,
  draftStatus?.EXTERNAL_SIGNATURE_PENDING,
  draftStatus?.INTERNAL_SIGNATURE_PENDING,
  draftStatus.SIGNATURE_ABORTED,
  draftStatus?.SIGNATURE_PENDING,
];
